"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class BankTransactionType extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "BankTransactionType";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/bank-transaction-types"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create bank transaction types.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/bank-transaction-types/" +
      this.code
    );
  }

  getAdminPath() {
    console.error("Cannot go to a bank transaction type.");
  }

  // Returns a string, or an array of strings (for multi-line)
  get searchResultTitle() {
    return this.displayName;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default BankTransactionType;
